/* eslint-disable */

import React from 'react';


// @ts-ignore
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from '../../../base/i18n';
import { IconArrowUp } from '../../../base/icons';
import { isLocalParticipantModerator } from '../../../base/participants';
import { ToolboxButtonWithIcon } from '../../../base/toolbox/components';
import { toggleHangUpSettings } from '../../../settings';
import HangupButton from '../HangupButton';

import HangUpSettingsPopup from './HangUpSettingsPopup';

declare var interfaceConfig: object;


function HangupSettings({ customClass, visible }) {
    const dispatch = useDispatch();
    const onVideoOptionsClick = () => dispatch(toggleHangUpSettings());
    const isModerator = useSelector(state => isLocalParticipantModerator(state));
    const { t } = useTranslation();
    const { interfaceConfig: intConfig } = useSelector(state => state['features/base/config']);
    const partipicipantss = useSelector(state => state['features/base/participants']);
    const isRemoteParticipants = partipicipantss.filter(it => it.local !== true) ?? [];
    const hangupOption  = intConfig.hangupOptions ?? interfaceConfig?.hangupOptions

    return (
         <HangUpSettingsPopup>
                <HangupButton
                    customClass = { customClass }
                    visible = { visible }
                    onClickWeb = { isModerator && isRemoteParticipants.length > 0 && hangupOption
                        ? onVideoOptionsClick : false } />
            </HangUpSettingsPopup>
    );
}

export default HangupSettings;
